<template>
    <div>
        <div class="redshiftMonitor-title">
            <div>{{ $t('RedshiftMonitor.redshift') }}</div>
            <div>
                <Button type="primary" @click="addOrUpdateHandle" v-hasPermission="['monitor:redshiftMonitor:add_alert_rule']">{{ $t('RedshiftMonitor.addRedshift') }}</Button>
                <add-or-update-redshift-warning v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-redshift-warning>
            </div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.redshift.redshiftList')">
                    <div class="redshiftMonitor-top">
                        <redshift-monitor-search></redshift-monitor-search>
                    </div>
                    <table-redshift></table-redshift>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import RedshiftMonitorSearch from '../redshift/RedshiftMonitorSearch'
    import TableRedshift from '../redshift/TableRedshift'
    import AddOrUpdateRedshiftWarning from '../redshift/AddOrUpdateRedshiftWarning'

    export default {
        name: 'RedshiftMonitor',
        components: {
            RedshiftMonitorSearch,
            TableRedshift,
            AddOrUpdateRedshiftWarning
        },
        data(){
            return {
                addOrUpdateVisible:false
            }
        },
         methods:{
            // 添加报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            }
        }
    }
</script>

<style scoped>
    .redshiftMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .redshiftMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .redshiftMonitor-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .redshiftMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/redshift/RedshiftMonitor.vue